import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {FormDefinitionFormModel} from "../../../api/entity/formDefinitionForm.model";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {FormDefinitionFormConverter} from "../../../api/entity/converter/formDefinitionForm.converter";

@Injectable()
export class FormDefinitionFormDataService extends AbstractDataServiceV2<FormDefinitionFormModel, FormDefinitionFormConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: FormDefinitionFormConverter) {
        super('FormDefinitionForm', http, httpUrlGenerator, logger, config, converter);
    }
}
